export default function CustomDot(props: any) {
  const { cx, cy, payload } = props;

  return (
    <g>
      <circle
        cx={cx}
        cy={cy}
        r={5}
        fill="hsl(var(--ocean))"
        stroke="white"
        strokeWidth={2}
      />
      <text
        x={cx}
        y={cy - 20}
        textAnchor="middle"
        fill="hsl(var(--foreground))"
        fontSize={14}
        fontWeight={500}
      >
        {payload.value}
      </text>
    </g>
  );
}
